export default {
    windowSize: state => {
        return state.windowSize
    },
    icmywealth: state => {
        return state.icmywealth
    },
    user: state => {
        return state.user
    },
    userType: state => {
        return state.user.type
    },
    activeAccount: state => {
        return state.activeAccount ?? state.user.customer
    },
	token: state => {
		return state.token;
	},
    customer: state => {
        return state.customer;
    },
    contactSubjects: state => {
        return state.contactSubjects
    },
    notificationTypes: state => {
        return state.notificationTypes
    },
    currencies: state => (locale = false) => {
        if (locale) {
            return state.currenciesLocale
        }
        return state.currencies
    },
    transactionTypes: state => {
        return state.transactionTypes
    },
    feeStatuses: state => {
        return state.feeStatuses
    },
    messageTopics: state => {
        return state.messageTopics
    },
    messageSubjects: state => {
        return state.messageSubjects
    },
    identificationTypes: state => (type = 'individual', exclude = []) => {
        if (type !== 'individual') {
            return _.without(state.identificationTypes, 'Birth Certificate', ...exclude)
        }
        return _.without(state.identificationTypes, ...exclude)
    },
    beneficialOwner: state => {
        return state.beneficialOwner
    },
    inboxLoad: state => {
        return state.inboxLoad
    },
    monthDays: state => {
        return state.monthDays
    },
    documentTypes: state => {
        return state.documentTypes
    },
    salutations: state => {
        return state.salutations
    },
    employmentTypes: state => {
        return state.employmentTypes
    },
    residencyStatus: state => {
        return state.residencyStatus
    },
    paymentTypes: state => {
        return state.paymentTypes
    },
    maturityTypes: state => {
        return state.maturityTypes
    },
    orderTypes: state => {
        return state.orderTypes
    },
    paymentServices: state => {
        return state.paymentServices
    },
	plans: state => state.plans,
	bankAccountTypes: state => state.bankAccountTypes,
    showAnnouncement: state => state.showAnnouncement && !state.hasDirectDebit,
    momoAccount: state => state.momoAccount,
    momoAccounts: state => state.momoAccounts,
	showIdUpdateModal: state => {
        const { account_type, is_id_expired, residency_status, identification_document_type, approval_status, kyc_status} = state.user.customer

		return (account_type === 'PRINCIPAL' && state.showIdUpdateModal && (is_id_expired || (residency_status === 'Resident Ghanaian' && identification_document_type !== 'National ID')) && approval_status === 'APPROVED' && kyc_status !== 'ID_APPROVAL') 
	},
    getIcmywealthBankAccountByCurrency: state => (type, currency) => {
        return state.icmywealth.bankAccounts[type][currency];
    },
    getIcmywealthBankAccountByType: state => (type) => {
        return state.icmywealth.bankAccounts[type];
    }
}
